module.exports = __webpack_public_path__ + "static/media/logo-full-default.49ef067f.svg";